export const buildAddCartByQuoteUrl = (appCtx, quoteId) => {
  const cntryLang = `${appCtx.lang.toLowerCase()}-${appCtx.country.toLowerCase()}`;
  return `${appCtx.envProp.appServer}bc/${cntryLang}/addCartByQuote?quoteIdForCart=${encodeURIComponent(quoteId)}`;
};
